// Helper function to calculate and update duty/tax
export const calculateDutyTaxFee = (dutyTaxAmount, bookingDatacharges) => {
  const dutyTaxCharge = {
    charge_code: "DFT",
    charge_description: "Duty Fees & Taxes",
    chargetype_id: 171,
    minimum_price: Number(dutyTaxAmount),
    multiply: false,
    price: Number(dutyTaxAmount),
  };
  return {
    ...bookingDatacharges,
    port_discharge_section: [
      ...bookingDatacharges.port_discharge_section,
      dutyTaxCharge,
    ],
  };
};

export const getInsuranceChargeForCommodities = (insuranceArr, bookingDataCharges) =>{
  let destinationInsuranceCharge = []
  for (const item of insuranceArr) {
    const isPolicyPresent =  ((item?.policy_id) != null)
    if(item.quote.result_code === "quote_created" && isPolicyPresent){
      const chargeObj = {
        charge_code: "INS",
        charge_description: "Insurance",
        chargetype_id: 237,
        minimum_price: Number(item.quote.premium_amount),
        multiply: false,
        price: Number(item.quote.premium_amount),
      }
      destinationInsuranceCharge = [
        ...destinationInsuranceCharge,
        chargeObj
      ]
    }
  }

  return {
    ...bookingDataCharges,
    port_discharge_section
    : [
      ...bookingDataCharges.port_discharge_section,
      ...destinationInsuranceCharge
    ]
  };
}

/**
 * @memberof module:util
 * @function
 * @name getBookingObject
 * @description if property '45hq' is missing/falsy only in a FCL rate card, then add it
 *
 * @param {Object} fclJSON - Full FCL json
 * @returns {Object}
 */
export const getBookingObject = (
  bookingData,
  queryParams,
  agentInformation,
  transactionType
) => {
  // console.log(
  //   "-----getBookingObject is executing----",
  //   bookingData,
  //   queryParams,
  //   agentInformation,
  //   transactionType
  // );

  const delivery_selected_index =
    bookingData?.selected_card_detail?.delivery_selected_option_index;

  const pickup_selected_index =
    bookingData?.selected_card_detail?.pickup_selected_option_index;

  let bookingObject = {
    carrier: bookingData?.selected_card_json?.carrier.id,
    charge_id: bookingData?.selected_card_json?.charge_id,
    charge_type_id: bookingData?.selected_card_json?.charge_type_id,
    container_type: bookingData?.form_params?.type?.includes("fcl")
      ? "FCL"
      : "LCL",

    vessel_service: bookingData?.selected_card_json?.vessel_Service.id,
    ETD_origin: bookingData?.selected_card_json?.etd_origin,
    rate: bookingData?.selected_card_json?.bookNowPrice,
    origin_port: queryParams?.from?.id,
    discharge_port: bookingData?.selected_card_json?.port_of_discharge.id,
    destination_port: queryParams?.to?.id,
    validity_from: bookingData?.selected_card_json?.valid_date_from,
    validity_to: bookingData?.selected_card_json?.valid_date_to,
    agent_info: agentInformation?.id,
    //shipper_info:isExistingPickupFactorySelected?.id,
    //delivery_location:isExistingDeliveryFactorySelected?.id,
    isDischargeChecked: bookingData?.selected_card_detail?.discharge_isChecked,
    isErsChecked: bookingData?.selected_card_detail?.ers_isChecked,
    isFreightChecked: bookingData?.selected_card_detail?.frieght_isChecked,
    isPortOriginChecked: bookingData?.selected_card_detail?.origin_isChecked,
    isPickupChecked: bookingData?.selected_card_detail?.pickup_isChecked,
    isDeliveryChecked: bookingData?.selected_card_detail?.delivery_isChecked,
    vendor_contract: bookingData?.selected_card_json?.vendor_contract?.id,
    mode_of_transport: bookingData?.selected_card_json?.mode,
    schedule_id: bookingData?.selected_card_detail?.selectedSchedule?.id,
    consignee_role:transactionType,
  };

  if (bookingData.form_params.type === "api-lcl") {
    bookingObject = {
      ...bookingObject,
      chargeable_weight: bookingData.form_params?.chargeableWeight,
      container_type: "LCL",
      freight_rate: Number(bookingData.form_params?.freightRate),
    };
  } else if (bookingData.form_params.type === "api-fcl") {
    bookingObject = {
      ...bookingObject,
      _20stCounter: bookingData?.container?._20stCounter,
      _40hqCounter: bookingData?.container?._40hqCounter,
      _40stCounter: bookingData?.container?._40stCounter,
      _45hqCounter: bookingData?.container?._45hqCounter,

      _20stPrice:
        bookingData.discount && bookingData.discount.id
          ? bookingData?.selected_card_detail?._20stPrice
          : Number(bookingData?.selected_card_json?.["20st"]),

      _40hqPrice:
        bookingData.discount && bookingData.discount.id
          ? bookingData?.selected_card_detail?._40hqPrice
          : Number(bookingData?.selected_card_json?.["40hq"]),

      _40stPrice:
        bookingData.discount && bookingData.discount.id
          ? bookingData?.selected_card_detail?._40stPrice
          : Number(bookingData?.selected_card_json?.["40st"]),

      _45hqPrice:
        bookingData.discount && bookingData.discount.id
          ? bookingData?.selected_card_detail?._45hqPrice
          : Number(bookingData?.selected_card_json?.["45hq"]),
      container_type: "FCL",
    };
  }

  const pickup_charges =
    bookingData?.selected_card_json?.pickup_section?.[pickup_selected_index] ||
    {};

  const delivery_section =
    bookingData?.selected_card_json?.delivery_section?.[
      delivery_selected_index
    ] || {};

  let deliveryRateArr = [];

  if (
    delivery_section &&
    delivery_section.hasOwnProperty("rate") &&
    Array.isArray(delivery_section.rate)
  ) {
    deliveryRateArr = bookingData?.selected_card_detail?.delivery_charges;
  }

  let pickupRateArr = [];
  if (
    pickup_charges &&
    pickup_charges.hasOwnProperty("rate") &&
    Array.isArray(pickup_charges.rate)
  ) {
    pickupRateArr = bookingData?.selected_card_detail?.pickup_charges;
  }

  const bookingDataCharges = {
    booking_data:bookingObject,
    ers_section: bookingData?.selected_card_detail?.ers_charges,
    port_origin_section:
      bookingData?.selected_card_detail?.port_fees_from_charges,
    port_discharge_section:
     bookingData?.selected_card_detail?.port_fees_to_charges,
    pickup_section_charges: pickupRateArr,
    pickup_section: pickup_charges,
    delivery_section: delivery_section,
    delivery_section_charges: deliveryRateArr,
    discountID: bookingData?.discount?.id,
  };

  return bookingDataCharges;
};

export const updateBookingDataCharges = (bookingDatacharges, shipperReceiverForm, dutyTax_amount_subtotal) => {
  if (shipperReceiverForm && shipperReceiverForm.custom_broker !== '') {
    let brokerageFee = 0;


    if (shipperReceiverForm.custom_broker === 'primeFreight') {
      brokerageFee = 75;
    }

    if (brokerageFee && brokerageFee > 0) {
      bookingDatacharges = calculateBrokerageFee(brokerageFee, bookingDatacharges);
    }
  }

  if (dutyTax_amount_subtotal && Object.keys(dutyTax_amount_subtotal).length > 0) {
    const totalDutyTaxAmount = (dutyTax_amount_subtotal.duties + dutyTax_amount_subtotal.taxes).toFixed(2);

    if (totalDutyTaxAmount && totalDutyTaxAmount > 0) {
      bookingDatacharges = calculateDutyTaxFee(totalDutyTaxAmount, bookingDatacharges);
    }
  }

  return bookingDatacharges;
};

// Helper function to calculate and update brokerage fee
export const calculateBrokerageFee = (brokerageFee, bookingDatacharges) => {
  const destinationBrokerageCharge = {
    charge_code: "BROK",
    charge_description: "Brokerage",
    chargetype_id: 81,
    minimum_price: Number(brokerageFee),
    multiply: false,
    price: Number(brokerageFee),
  };

  return {
    ...bookingDatacharges,
    port_discharge_section: [
      ...bookingDatacharges.port_discharge_section,
      destinationBrokerageCharge,
    ],
  };
};